import { X, Home, BookOpen, HelpCircle, User, LayoutDashboard, LogOut, ShoppingBag, BookMarked, FileDown, Gift } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_1791f9d8-ffce-4632-931c-e01b5c5c94c3/artifacts/sbeyyf6q_1000003487.png";
const INSTRUCTOR_PHOTO = "https://customer-assets.emergentagent.com/job_1791f9d8-ffce-4632-931c-e01b5c5c94c3/artifacts/fn2eo02h_1000003634.jpg";

export default function Sidebar({ open, onClose }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const go = (path) => {
    navigate(path);
    onClose();
  };

  const handleLogout = async () => {
    await logout();
    navigate("/login");
    onClose();
  };

  if (!open) return null;

  const links = [
    { label: "Home", icon: Home, path: "/" },
    { label: "All Courses", icon: BookOpen, path: "/courses" },
    { label: "E-Books (Paid)", icon: FileDown, path: "/ebooks" },
    { label: "Free E-Books", icon: Gift, path: "/free-ebooks" },
    { label: "Printed Books", icon: BookMarked, path: "/printed-books" },
    { label: "My Courses", icon: ShoppingBag, path: "/my-courses" },
    { label: "Profile", icon: User, path: "/profile" },
    { label: "Help", icon: HelpCircle, path: "/help" },
  ];

  if (user?.role === "admin") {
    links.push({ label: "Admin Panel", icon: LayoutDashboard, path: "/admin" });
  }

  return (
    <>
      <div
        data-testid="sidebar-overlay"
        className="fixed inset-0 bg-black/60 z-[60]"
        onClick={onClose}
      />
      <aside
        data-testid="sidebar-drawer"
        className="fixed top-0 left-0 bottom-0 w-72 bg-slate-900 text-white z-[70] flex flex-col"
      >
        {/* Header */}
        <div className="p-6 bg-[#0284C7] flex items-center gap-4">
          <img src={LOGO_URL} alt="Logo" className="w-12 h-12 object-contain" />
          <div className="flex-1 min-w-0">
            <p className="font-bold text-sm truncate">{user?.name || "Guest"}</p>
            <p className="text-xs text-white/80 truncate">{user?.email || ""}</p>
          </div>
          <button onClick={onClose} className="p-1" data-testid="sidebar-close-btn">
            <X size={20} />
          </button>
        </div>

        {/* Links */}
        <nav className="flex-1 py-4">
          {links.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.path}
                data-testid={`sidebar-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => go(item.path)}
                className="w-full flex items-center gap-4 px-6 py-3.5 text-left text-sm font-medium text-slate-200 hover:bg-slate-800 transition-none"
              >
                <Icon size={18} />
                {item.label}
              </button>
            );
          })}
        </nav>

        {/* Instructor section */}
        <div className="px-6 py-4 border-t border-slate-700">
          <div className="flex items-center gap-3 mb-3">
            <img src={INSTRUCTOR_PHOTO} alt="Instructor" className="w-10 h-10 object-cover" />
            <div>
              <p className="text-xs text-slate-400">Your Instructor</p>
              <p className="text-sm font-bold">Smart English</p>
            </div>
          </div>
        </div>

        {/* Logout */}
        <button
          data-testid="sidebar-logout-btn"
          onClick={handleLogout}
          className="flex items-center gap-4 px-6 py-4 text-red-400 font-medium text-sm border-t border-slate-700 transition-none hover:bg-slate-800"
        >
          <LogOut size={18} />
          Logout
        </button>
      </aside>
    </>
  );
}
